// extracted by mini-css-extract-plugin
export default {"personItem":"PersonItem_personItem__h6sa0","personInfo":"PersonItem_personInfo__CaKVn"};